import { Component } from '@angular/core';

@Component({
    templateUrl: './privacy-page.component.html'
})
export class PrivacyPageComponent {}
